import { ArrowUpRight } from "lucide-react";

export default function CtaBanner() {
    return (
        <section
            data-testid="cta-banner"
            className="relative bg-white px-6 md:px-12 lg:px-24 py-20 md:py-28 overflow-hidden"
        >
            <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                {/* Image */}
                <div className="lg:col-span-5 order-2 lg:order-1">
                    <div className="relative">
                        <div className="relative aspect-[6/5] overflow-hidden bg-[#FAFAFA]">
                            <img
                                src="/melanie-extra.png"
                                alt="Mélanie Perez — contactez-moi, créatrice UGC à Bordeaux"
                                className="w-full h-full object-cover"
                                loading="lazy"
                            />
                        </div>
                        {/* Gold frame ornament */}
                        <span className="hidden md:block absolute -top-4 -left-4 w-20 h-20 border border-gold" />
                        <span className="hidden md:block absolute -bottom-4 -right-4 w-16 h-16 bg-fuchsia/15" />
                    </div>
                </div>

                {/* Text */}
                <div className="lg:col-span-7 order-1 lg:order-2">
                    <p className="eyebrow mb-6">Prête à passer à l'action</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.02]">
                        Votre marque mérite<br />
                        un contenu qui <span className="italic text-fuchsia">marque</span>.
                    </h2>
                    <p className="mt-8 max-w-xl text-[#4A4A4A] text-base md:text-lg leading-relaxed">
                        On scrolle pendant <span className="text-ink font-medium">7 secondes</span>{" "}avant de décider si on s'arrête sur un contenu. Mon job : faire en sorte
                        qu'on s'arrête sur le vôtre — et qu'on clique pour acheter.
                    </p>

                    <div className="mt-10 flex flex-wrap items-center gap-5">
                        <a
                            href="#contact"
                            data-testid="cta-banner-button"
                            className="inline-flex items-center gap-3 bg-bordeaux text-white px-8 py-4 text-xs uppercase tracking-[0.22em] hover:bg-fuchsia transition-colors"
                        >
                            Démarrer un projet
                            <ArrowUpRight className="w-4 h-4" />
                        </a>
                        <a
                            href="https://www.instagram.com/melanie.creatrice/"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="cta-banner-instagram"
                            className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.22em] text-ink hover:text-fuchsia transition-colors"
                        >
                            DM Instagram
                            <span className="w-8 h-px bg-current" />
                        </a>
                    </div>

                    <div className="mt-12 max-w-md">
                        <p className="text-sm text-[#4A4A4A] leading-relaxed">
                            Basée à Bordeaux &middot; disponible partout en France pour
                            tournages, événements et campagnes.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
